import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import ButtonTypes from '../../constants/buttonTypes';
import { ReactComponent as IconLoader } from '../../assets/icon/ic_loading.svg';

const ConfirmModal = ({
  visible, toggleVisible, confirmButtonText, confirmText, onConfirm, onCancel, loading, cancelButtonText
}) => {
  ReactModal.setAppElement('#root');

  return (
    <ReactModal
      isOpen={visible}
      className="border-none bg-[rgba(30,30,45,.3)]"
      overlayElement={(props, contentElement) => (
        <div
          className="z-[11] fixed w-full h-full bg-[rgba(30,30,45,.3)] top-0 left-0"
        >
          {contentElement}
        </div>
      )}
    >
      <div className="absolute flex justify-center items-center w-full h-full top-0 left-0">
        <div
          className={[
            'h-max justify-center items-center flex flex-col min-w-[350px] z-[10]',
            'bg-white dark:bg-background-dark rounded-[8px] p-[30px]',
            'shadow-default animate__animated animate__fadeInDown animate__faster'
          ].join(' ')}
        >
          <div className="p-[25px]">
            {visible && (
            <div className="flex flex-col justify-center items-center">
              <div
                className="w-[70px] h-[70px] rounded-full border-2 border-warning mb-[27px]
                flex justify-center items-center"
              >
                <div className="text-[48px] text-warning">!</div>
              </div>
              <div>
                {confirmText}
              </div>
            </div>
            )}
          </div>
          <div className="flex flex-row justify-center">
            {loading ? <IconLoader widht={100} height={50} className="spin" />
              : (
                <>
                  {onConfirm && (
                    <Button
                      text={confirmButtonText}
                      onClick={onConfirm}
                      type={ButtonTypes.DANGER}
                      containerStyle="mr-[10px]"
                    />
                  )}
                  <Button
                    text={cancelButtonText}
                    onClick={() => {
                      toggleVisible();
                      onCancel();
                    }}
                    type={ButtonTypes.WHITE}
                  />
                </>
              )}
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

ConfirmModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmButtonText: PropTypes.string,
  confirmText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelButtonText: PropTypes.string,
  loading: PropTypes.bool
};

ConfirmModal.defaultProps = {
  toggleVisible: () => {},
  onConfirm: undefined,
  onCancel: () => {},
  visible: false,
  loading: false,
  confirmButtonText: 'Confirm',
  cancelButtonText: 'No, Cancel',
  confirmText: 'Are you sure you want continue?',
};

export default ConfirmModal;
